/*
 * @Author: 程序员
 * @Description: axios二次封装拦截
 * @explain: axios已拓展到vue原型上，可直接使用this.$http.xxx调用
 * @example: 使用示例见../services/commonApi.js
 * @Date: 2021-06-07 09:56:16
 */
import Vue from "vue";
import axios from "axios";
import qs from "qs";
// import store from "../store";
import router from "../router";
import ErrorCode from "./errorCode";
import { apiUserLoginOut } from "../services/commonApi";

// import
// import { Notify, Dialog } from "vant";
// 根据运行环境配置请求服务基础路径
if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = ""; // 开发环境
} else if (process.env.NODE_ENV === "debug") {
  axios.defaults.baseURL = ""; // 调试环境
} else if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = ""; // 生产环境
}
//请求超时
axios.defaults.timeout = 20000;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.Authorization
    // token && (config.headers.Authorization = token)
    // return config

    if (
      config.method === "post" &&
      config.headers?.["Content-Type"] !== "application/json"
    ) {
      if (
        config.data &&
        Object.prototype.toString.call(config.data) == "[object FormData]"
      ) {
        //附件上传配置处理
        config.headers["Content-Type"] = "multipart/form-data";
      } else {
        //表单数据格式处理
        if (config.url.indexOf("/rdcm/manage/") !== -1) {

        } 
        else {
          config.data = qs.stringify(config.data);
        }

        if (config.url.indexOf("/rdcm/manage/") !== -1) {
          config.headers["Content-Type"] =
            config.headers["Content-Type"] || "application/json";
        }
      }
      
    }

    //票据是否本地存储
    if (localStorage.getItem("Authorization")) {
      config.headers.common["Authorization"] =
        localStorage.getItem("Authorization");
    }
    return config;
  },
  (error) => {
    return Promise.error(error);
  }
);
// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    let errorCode = response.data.errorCode || response.data.code;
    if (response.status === 200 && ErrorCode["ok"].includes(errorCode)) {
      //浏览器响应码200且接口错误码值为ok
      return Promise.resolve(response);
    } else if (
      Object.prototype.toString.call(response.data) === "[object Blob]"
    ) {
      //文件流
      return Promise.resolve(response);
    } else {
      //请求失败处理
      Vue.prototype.$message.destroy();
      Vue.prototype.$message.error(response.data.message);
      if (ErrorCode["time_out_error"].includes(errorCode)) {
        //会话超时，跳转到登录页
        window.localStorage.clear();
        window.sessionStorage.clear();
        if (!["login"].includes(router.currentRoute.name)) {
          if (["loginAdmin"].includes(router.currentRoute.name)) {
            setTimeout(() => {
              window.location.href = "/loginAdmin";
            }, 1000);
          } else {
            setTimeout(() => {
              window.location.href = "/user/login";
            }, 1000);
          }
        }
      } else {
        switch (errorCode) {
          case ErrorCode["not_authenticate"]:
            window.localStorage.clear();
            window.sessionStorage.clear();
            if (!["login"].includes(router.currentRoute.name)) {
              if (["loginAdmin"].includes(router.currentRoute.name)) {
                setTimeout(() => {
                  window.location.href = "/loginAdmin";
                }, 1000);
              } else {
                setTimeout(() => {
                  window.location.href = "/user/login";
                }, 1000);
              }
            }
            break;
          case ErrorCode["license_check_error"]:
            router.replace({
              name: "notLicense",
            });
            break;
          case ErrorCode["no_permission"]:
            apiUserLoginOut().then(() => {
              window.localStorage.clear();
              window.sessionStorage.clear();
              setTimeout(() => {
                window.location.href = "/user/login/login_out/";
              }, 3000);
            });
            break;
          default:
            break;
        }
      }

      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  (error) => {
    if (error.response.status) {
      Vue.prototype.$message.destroy();
      Vue.prototype.$message.error("请求服务失败~");
      /*switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          Vue.prototype.$message.error("请登录后操作");
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Vue.prototype.$message.error("登录过期，请重新登录");
          // 清除用户
          Vue.prototype.$store.commit("mtt_removeUser", null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          Vue.prototype.$message.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          Vue.prototype.$message.error("请求失败，请登录后操作");
          setTimeout(() => {
            router.replace({
              path: "/login",
            });
          }, 1000);
      }*/
      return Promise.reject(error);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {get} from './request';export const requestGet = params => get('url', params);]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {post} from './request';export const requestPost = params => post('url', params);]
 */
export function post(url, params, config = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * head方法，对应head请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {head} from './request';export const requestHead = params => head('url', params);]
 */
export function head(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .head(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * options方法，对应options请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {options} from './request';export const requestOptions = params => options('url', params);]
 */
export function options(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .options(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * del方法（delete为保留字，不可使用），对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {del} from './request';export const requestDel = params => delete('url', params);]
 */
export function del(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        data: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {put} from './request';export const requestPut = params => put('url', params);]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * patch方法，对应patch请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {patch} from './request';export const requestPatch = params => patch('url', params);]
 */
export function patch(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * customRequest方法，对应自定义请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {customRequest} from './request';export const requestPatch = params => customRequest('url', params, method);]
 */

export function customRequest(url, params, method = "post") {
  const createAxios = axios.create({});
  // 请求拦截器
  createAxios.interceptors.request.use(
    (config) => {
      if (config.method === "post") {
        if (
          config.data &&
          Object.prototype.toString.call(config.data) == "[object FormData]"
        ) {
          //附件上传配置处理
          config.headers["Content-Type"] = "multipart/form-data";
        } else {
          //表单数据格式处理
          config.data = qs.stringify(config.data);
        }
      }
      //票据是否本地存储
      if (localStorage.getItem("Authorization")) {
        config.headers.common["Authorization"] =
          localStorage.getItem("Authorization");
      }
      return config;
    },
    (error) => {
      return Promise.error(error);
    }
  );
  // 响应拦截器
  createAxios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return new Promise((resolve, reject) => {
    createAxios
      .request({
        url,
        method,
        data: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * body请求方式
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {customRequest} from './request';export const requestPatch = params => customRequest('url', params, method);]
 */

export function customBodyRequest(url, params, method = "post") {
  const createAxios = axios.create({});
  // 请求拦截器
  createAxios.interceptors.request.use(
    (config) => {
      // if (config.method === "post") {
      //   config.data = qs.stringify(config.data);
      // }
      //票据是否本地存储
      if (localStorage.getItem("Authorization")) {
        config.headers.common["Authorization"] =
          localStorage.getItem("Authorization");
      }
      return config;
    },
    (error) => {
      return Promise.error(error);
    }
  );
  // 响应拦截器
  createAxios.interceptors.response.use(
    (response) => {
      let errorCode = response.data.errorCode || response.data.code;
      if (response.status === 200 && ErrorCode["ok"].includes(errorCode)) {
        //浏览器响应码200且接口错误码值为ok
        return Promise.resolve(response);
      } else if (
        Object.prototype.toString.call(response.data) === "[object Blob]"
      ) {
        //文件流
        return Promise.resolve(response);
      } else {
        //请求失败处理
        Vue.prototype.$message.destroy();
        Vue.prototype.$message.error(response.data.message);
        if (ErrorCode["time_out_error"].includes(errorCode)) {
          //会话超时，跳转到登录页
          window.localStorage.clear();
          window.sessionStorage.clear();
          if (!["login"].includes(router.currentRoute.name)) {
            if (["loginAdmin"].includes(router.currentRoute.name)) {
              setTimeout(() => {
                window.location.href = "/loginAdmin";
              }, 1000);
            } else {
              setTimeout(() => {
                window.location.href = "/user/login";
              }, 1000);
            }
          }
        } else {
          switch (errorCode) {
            case ErrorCode["not_authenticate"]:
              window.localStorage.clear();
              window.sessionStorage.clear();
              if (!["login"].includes(router.currentRoute.name)) {
                if (["loginAdmin"].includes(router.currentRoute.name)) {
                  setTimeout(() => {
                    window.location.href = "/loginAdmin";
                  }, 1000);
                } else {
                  setTimeout(() => {
                    window.location.href = "/user/login";
                  }, 1000);
                }
              }
              break;
            case ErrorCode["license_check_error"]:
              router.replace({
                name: "notLicense",
              });
              break;
            case ErrorCode["no_permission"]:
              apiUserLoginOut().then(() => {
                window.localStorage.clear();
                window.sessionStorage.clear();
                setTimeout(() => {
                  window.location.href = "/user/login/login_out/";
                }, 3000);
              });
              break;
            default:
              break;
          }
        }

        return Promise.reject(response);
      }
    },
    // 服务器状态码不是200的情况
    (error) => {
      if (error.response.status) {
        Vue.prototype.$message.destroy();
        Vue.prototype.$message.error("请求服务失败~");
        /*switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          Vue.prototype.$message.error("请登录后操作");
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath,
            },
          });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          Vue.prototype.$message.error("登录过期，请重新登录");
          // 清除用户
          Vue.prototype.$store.commit("mtt_removeUser", null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/login",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
          }, 1000);
          break;
        // 404请求不存在
        case 404:
          Vue.prototype.$message.error("网络请求不存在");
          break;
        // 其他错误，直接抛出错误提示
        default:
          Vue.prototype.$message.error("请求失败，请登录后操作");
          setTimeout(() => {
            router.replace({
              path: "/login",
            });
          }, 1000);
      }*/
        return Promise.reject(error);
      }
    }
  );
  return new Promise((resolve, reject) => {
    createAxios
      .request({
        url,
        method,
        data: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @example [import {post} from './request';export const requestPost = params => post('url', params);]
 */
export function bodyPost(url, params, config = {}) {
  return customBodyRequest(url, params, "post");
}
